
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/categories/[id]/books",
      function () {
        return require("private-next-pages/categories/[id]/books.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/categories/[id]/books"])
      });
    }
  